export default __webpack_public_path__ + "static/media/smileySearch.b3fa00f5.svg";